import { motion } from "framer-motion";
import { Gift, Sparkles } from "lucide-react";

export default function HeroSection() {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
      className="base44Hero"
    >
      <div className="base44HeroBlob base44HeroBlobOne" />
      <div className="base44HeroBlob base44HeroBlobTwo" />

      <div className="base44HeroContent">
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ delay: 0.3, type: "spring", stiffness: 200 }}
          className="base44HeroBadge"
        >
          <Sparkles size={16} />
          AI-Powered Gift Discovery
        </motion.div>

        <h1 className="base44HeroTitle">
          Find the <span>Perfect Gift</span>
          <br />
          for Every Heart
        </h1>

        <p className="base44HeroSubtitle">
          Tell us about your loved one, and our AI will discover heartfelt,
          meaningful gifts that speak directly to their soul.
        </p>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.6 }}
          className="base44HeroFeatures"
        >
          <span>
            <Gift size={16} />
            Personalized Picks
          </span>

          <div className="base44HeroDivider" />

          <span>
            <Sparkles size={16} />
            Emotionally Intelligent
          </span>
        </motion.div>
      </div>
    </motion.div>
  );
}